<template>
  <div>
    <div class="header-bar">
      <div class="left">
        <div class="logo" @click="goHome">
          <div class="[currentWidth > 1280 ? 'widthClass' : 'widthClassOther']"><img v-if="dynamicData.logo" :src="dynamicData.logo" alt="" /></div>
          <div class="title-height"><span v-if="['DF', 'EC'].includes($util.judgeOrigin()) && $route.path !== '/home'" >{{ dynamicData.productTitle }}</span></div>
        </div>

        <span v-if="products.length > 1 && $route.path !== '/' && $route.path !== '/home'" size="mini" @click.stop="changeShowProduct">
          <span class="check-product-btn"><svg-icon name="changp"></svg-icon></span>
        </span>
      </div>
      <password-modification> </password-modification>
      <!-- <div class="select"  v-if="$route.path !== '/home'" >
      <el-select v-model="value" size="mini">
        <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value"> </el-option>
      </el-select>
    </div> -->
      <nav-bar class="nav" v-if="$route.path !== '/home'" :key="langs" :menu="nav" :active="$route.path" active-key="path" @change="changeNav"></nav-bar>
      <div class="right right-dis">
        <!-- <img  src="@/assets/help.png" alt=""> -->
        <span class="help-icon"  @click="moreMessage" v-if="DFAuth && $route.path !== '/home'">
        <svg-icon v-if="msgStatus" name="redmsg"></svg-icon>
         <svg-icon v-else name="msg"></svg-icon>
        </span>
        <span class="help-icon" @click="helpClick" v-if="DFAuth && $route.path !== '/home'&& this.$util.getCurrentProductName()=='gt6'"><svg-icon name="question"></svg-icon></span>
        <div class="login-btns" v-if="!token">
          <span @click="goLogin" class="text-btn">{{ $t('components.header.login') }}</span>
          <!-- <span class="text-btn-back">注册</span> -->
          <!-- <el-button size="small" type="text" class="text-btn">登录</el-button>
        <el-button size="small" class="confirm-btn">注册</el-button> -->
        </div>
        <div class="login-btns" v-else>
          <!-- <span @click="goLogin" class="text-btn" v-if="$route.path === '/home'" @click="$router.push('/dashboard')">进入系统</span> -->
          <el-button style="margin-right: 12px" v-if="$route.path === '/home'" size="small" class="confirm-btn" @click="$router.push('/dashboard')">{{ $t('homes.enterSystem') }}</el-button>
          <div class="head">
            <span v-if="langShow">
              <span :class="isHome ? 'color' : 'white'">{{ accountInfo.email }}</span>
            </span>
            <span v-else>
              <span :class="isHome ? 'color' : 'white'" v-if="currentWidth >= 1440">{{ accountInfo.email }}</span>
            </span>
            <el-badge :hidden="!userInfo.updateStatus" is-dot class="item">
              <div class="head-img" @click.stop="goUserCenter">
                <el-dropdown size="medium" @command="handleCommand" class="dropdown">
                  <span class="el-dropdown-link">
                    <span v-if="accountInfo.email" class="head-user">{{ accountInfo.email.slice(0, 2).toUpperCase() }}</span>
                    <svg-icon v-else name="head"></svg-icon>
                  </span>
                  <el-dropdown-menu slot="dropdown" style="margin-top: 22px; width: 128px; text-align: center; left: 1288px">
                    <el-dropdown-item command="a" v-if="$util.judgeOrigin() == 'DF' || $util.judgeOrigin() == 'TR'">{{ $t('components.header.updateAnnouncement') }}</el-dropdown-item>
                    <el-dropdown-item command="b">{{ $t('components.header.accountCenter') }}</el-dropdown-item>
                    <el-dropdown-item command="d" v-if="['DF', 'EC'].includes($util.judgeOrigin())">
                      <span class="label label-important" @click="changeLang()">{{ lang }}</span></el-dropdown-item
                    >
                    <el-dropdown-item command="c" divided>{{ $t('components.header.LogOut') }}</el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
              </div>
            </el-badge>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import NavBar from '@/components/NavBarHeader'
import PasswordModification from '@/components/PasswordModification'
import $util from '@/utils/utils'
import store from '@/store/index'
export default {
  name: 'HeaderBar',
  components: {
    NavBar,
    PasswordModification,
  },
  computed: {
    currentWidth() {
      return document.documentElement.clientWidth
    },
    // 只给ET权限
    DFAuth() {
      return ['DF', 'EC'].includes(this.$util.judgeOrigin())
    },
    token() {
      return localStorage.getItem("accessToken")
    },
    userInfo() {
      return this.$store.getters.user
    },
    isHome() {
      return this.$route.path === '/' || this.$route.path === '/home'
    },
    accountInfo() {
      return localStorage.getItem("set_account_info")?JSON.parse(localStorage.getItem("set_account_info")):this.$store.getters.accountInfo;
    },
    langs() {
      return localStorage.getItem('language')
    },
    showProduct() {
      return this.$store.getters.showProduct
    },
    //在土耳其展示土耳其对应的biviologo
    isShowLogo() {
      return this.$util.judgeOrigin() == 'TR' ? true : this.$route.path === '/home' || this.$route.path === '/'
    },
  },
  watch: {
    lang(val) {
      this.getRules(1)
      this.handleGetUserInfo()
    },
    menuRole: {
      handler(val, oldVal) {
        console.log(val, 'wkiiii');
        if (val && val.length) {
          this.handleSetNav(val)
        }
      },
      immediate: true,
      deep: true
    },
    'dynamicData.lang': {
      handler(val, oldVal) {
        // 报告下载不走权限校验，翻译时候需要重新获取菜单名字，必须判断语言信息都存在，否则进入页面就会重新判断，然后请求接口了
        if (val && val !== this.langs) {
          this.getCustomMenuData(true)
          this.saveMenu()
          // setTimeout(()=>{
          //   window.location.reload();
          // }, 300)
        }
      },
      immediate: true,
    },
    'accountInfo.products': {
      handler(val) {
        this.handleGetProducts(val)
      },
      immediate: true,
    },
    'accountInfo.account_type_name': {
      handler(val) {
        this.getUserPlate(val)
      },
      immediate: true,
    },
  },
  data() {
    return {
      msgStatus:false,
      langShow: localStorage.getItem('language') == 'en' ? false : true,
      lang: localStorage.getItem('language') == 'en' ? '中文' : 'English',
      dynamicData: localStorage.getItem('gt6_dynamic') ? JSON.parse(localStorage.getItem('gt6_dynamic')) : this.$store.getters.dynamicGT6Data,
      products: [],
      nav: [],
      navData: [
        {
          name: '总览',
          path: '/dashboard',
        },
        {
          name: '特意搜搜',
          path: '/company',
        },
        {
          name: '商业数据',
          path: '/business',
        },
        {
          name: '贸易情报',
          path: '/trade',
        },
        {
          name: '产品分析',
          path: '/product',
        },
        {
          name: '趋势分析',
          path: '/trend',
        },
        // {
        //   name: '我的关注',
        //   path: '/collect'
        // }
      ],
      menuRole: [],
      datb: [],
      options: [
        {
          label: '切换',
          value: 0,
        },
      ],
      value: 0,
      domainNames: ['JM', 'EC'],
      accountTypeName: '',
    }
  },
  created() {
    // window.addEventListener('setItem', (e) => {
    //     // console.log("abcffff111")
    // })
    // 如果是br的话延时处理
    let tokenActive = localStorage.getItem('tokenActive')
    tokenActive = 1*tokenActive
    if(this.$route.query.brToken) {
      if (this.$util.isLogin() && tokenActive ) {
        this.getRules()
      }
    } else {
      if (this.$util.isLogin()) {
        this.getRules()
        this.getMesageList()
        this.getUserInfode()
        // 获取用户信息
        this.handleGetUser()
      }
    }
    window.addEventListener('setItemEvent', (e) => {
      if (e.key == 'gt6_dynamic') {
        this.dynamicData = JSON.parse(e.newValue)
      }
    })
  },
  methods: {
    moreMessage() {
      let url = this.$util.getCurrentWebSite() + '/gt6/user?id=3'
      window.open(url, '_self')
    },
    handleSetNav(val) {
      let data = this.$router.options.routes
      let date = this.menuRole
      let menus = this.dynamicData.menus || []
      for (let i = 0; i < data.length; i++) {
        for (let t = 0; t < date.length; t++) {
          if (data[i].namet == date[t].key) {
            this.$set(data[i], 'show', date[t].show)
            this.$set(data[i], 'hide', date[t].hide)
            // 菜单权限 0禁用1启用2隐藏
            this.$set(data[i], 'value', date[t].value)
          }
        }
      }
      let res = data
        .filter((item) => !item.hidden)
        .map((item, i) => {
          return {
            ...item,
            name: item.meta.name || menus[i],
            path: item.path,
            show: item.show,
            URL: this.$util.getCurrentWebSiteByProduct() + `${item.path}`,
          }
        })
      this.nav = res
    },
    goHome() {
      this.closeHelpDoc()
      this.$router.push('/home')
    },
    // 查看是否有用户信息缓存
    handleGetUser() {
      if(localStorage.getItem("gt6_user_info")==null) {
        this.$api.user.getUserInfo().then(res => {
          if(res.code==200) {
            this.$store.commit('set_user_info', res.data)
            localStorage.setItem('gt6_user_info', JSON.stringify(res.data))
          }
        })
      }
    },
    // 重新定义菜单
    handleGetProducts(val) {
      let data = val || []
      let pro = this.$util.judgeOrigin()
      //判断当前是否是土耳其
      if(['TR','EC'].includes(pro)) {
        let origin = location.origin.indexOf('localhost')>=0 ? 'https://export.bilvio.com' : location.origin
        //判断
        data = data.filter(item=>['gt6','gt5', 'yisou3'].includes(item.key))
      } else if(['JM'].includes(pro)) {
        data = data.filter(item=>['gt5'].includes(item.key))
      }
      this.products = data
    },
    // 获取用户平台
    getUserPlate(user) {
      this.accountTypeName = user
    },
    // 获取用户信息
    getUserInfode(){
      if(localStorage.getItem("set_account_info")==null) {
        this.$api.dashboard.getUserInfo().then(res => {
          if(res.code==200) {
            this.$store.commit('set_account_info', res.data)
            window.localStorage.setItem("set_account_info", JSON.stringify(res.data));
          }
        })
      }
    },
    getCustomMenuData(flag) {
      this.$api.user.getCustomData().then((res) => {
        if (res && res.code == 200) {
          this.$store.commit('dynamic_data', { ...res.data, lang: localStorage.getItem('language') })
          window.localStorage.setItem('gt6_dynamic', JSON.stringify({ ...res.data, lang: localStorage.getItem('language') }))
          this.lang = localStorage.getItem('language') == 'en' ? '中文' : 'English'
          if (!flag) {
            if (this.langShow) {
              this.$message({
                message: '语言切换成功',
                type: 'success',
              })
            } else {
              this.$message({
                message: 'switch language success',
                type: 'success',
              })
            }
          }
        } else {
          this.$message({
            message: '语言切换失败',
            type: 'success',
          })
        }
      })
    },
    // 重新获取英文版产品信息
    handleGetUserInfo() {
      this.$api.dashboard.getUserInfo().then((res) => {
        if (res.code == 200) {
          this.$store.commit('set_account_info', res.data)
          localStorage.setItem("set_account_info", JSON.stringify(res.data));
        }
      })
      .catch((err) => {
        console.log(err);
      })
    },
    changeLang() {
      this.langShow = !this.langShow
      let setLang = this.langShow ? 'zh' : 'en'
      localStorage.setItem('language', setLang)
      this.getCustomMenuData()
      sessionStorage.getItem('trade_result_params') ? sessionStorage.removeItem('trade_result_params') : ''
    },
    getRules(num) {
      if (num && num == 1) {
        this.saveMenu(num)
      } else {
        if (localStorage.getItem('gt6_getRules') && localStorage.getItem('gt6_getRules')!='null') {
          let data = JSON.parse(localStorage.getItem('gt6_getRules'))
          console.log(data, 'rules');
          this.menuRole = data.menuRole
          this.xiaoyiStatus()
        } else {
          this.saveMenu()
        }
      }
    },
    xiaoyiStatus(){
      this.$emit('xiaoyiStatus',JSON.parse(localStorage.getItem('gt6_getRules')).extendRule.allowXy)
    },
    saveMenu(num) {
      this.$api.user.getRules().then((res) => {
        localStorage.setItem('gt6_getRules', JSON.stringify(res.data))
        //将数据存在vueX
        console.log(res.data, 'menuRules');
        this.menuRole = res.data.menuRole
         this.xiaoyiStatus()
        if (num && num == 1) {
          window.location.reload()
          this.xiaoyiStatus()
        }
      })
    },
    handleCommand(command) {
      this.closeHelpDoc()
      let det = command
      if (det == 'c') {
        let thit = this
        this.$confirm(this.$t('message.confirm.wantLogout'), this.$t('tips')).then(function () {
            // thit.store.commit('set_token', null)
            localStorage.setItem("LogOut",true)
            window.location.href = thit.$util.getLoginUrl()
        })
      } else if (det == 'a') {
        // this.$router.push('/user')
        this.$router.push({ path: '/user', query: { id: '1' } })
      } else if (det == 'b') {
        // this.$router.push('/user')
        this.$router.push({ path: '/user', query: { id: '2' } })
      }
    },
    goUserCenter() {
      if (this.userInfo.updateStatus) {
        this.$store.dispatch('setUpdateStatus')
      }
      const data = {
        action_id: 13,
        module_id: 2,
        content: JSON.stringify({
          nav: 5,
        }),
      }
      // this.$api.logs.postCustomerLogs(data)
      this.closeHelpDoc()
      this.$router.push({ path: '/user', query: { id: this.$util.judgeOrigin() == 'DF' ? '1' : '2' } })
    },
    changeNav(nav) {
      console.log(nav, 'nav');
      // this.$router.push(nav.path);
      if (nav.value === 1) {
        this.closeHelpDoc()
        this.$router.push(nav.path)
      } else {
        this.$message.warning(this.$i18.language('「该模块白银版及以上版本用户开放」'))
      }
    },
    goLogin() {
      this.$util.loginOutUrl(this.$route.fullPath)
    },
    changeShowProduct(e) {
      this.$store.commit('change_show_product')
    },
    closeHelpDoc() {
      this.$emit('closeHelpDoc')
    },
    // 帮助点击
    helpClick() {
      this.$emit('changeHelp')
    },
    getMesageList() {
      this.$nextTick(() => {
        let sendParams = {
          status:1, //0 全部内容  1 未读 2 已读
          type: 2, //0 所有通知  1 数据更新通知 2 纠错回复消息
        };
        this.$api.public.getMesageList(sendParams).then((res) => {
          if (res && res.code == 200) {
            if(res.data.total>0){
              this.msgStatus=true
            }
          }
        });
      });
    }
  },
}
</script>

<style lang="scss" scoped>
.white{
  margin-right:0px!important;
  margin-left:5px;
}
.notice-style-show {
  position: relative;
  top: 0;
  left: 0;
  width: 100%;
  text-align: center;
  background: #979797;
  font-size: 12px;
  color: #ffffff;
  animation: myfirst 3s ease-in-out;
  -webkit-animation: myfirst 3s ease-in-out; /* Safari 与 Chrome */
}
.show {
  visibility: visible;
}
.hide {
  height: 0;
  visibility: hidden;
}
.label-important {
  cursor: pointer;
  width: 100%;
  height: 30px;
  display: inline-block;
}
.translate-lanage {
  position: absolute;
  right: 252px;
}
.el-dropdown-link {
  cursor: pointer;
  color: #409eff;
  top: 50px;
  margin-right:0px!important;
}
.el-icon-arrow-down {
  font-size: 12px;
}
.widthClass {
  width: 108px;
  margin-right: 15px;
}
.widthClassOther {
  width: 108;
  margin-left: 10px;
}
.header-bar {
  display: flex;
  height: 60px;
  align-items: center;
  justify-content: space-between;
  padding: 0 20px;
  border-bottom: 1px solid $--border-color-primary-6;
  .left {
    display: flex;
    align-items: center;
    // padding: 10px;
  }
  .logo {
    // width: 208px;

    text-align: center;
    display: flex;
    justify-content: space-between;
    cursor: pointer;
    .title-height {
       display:flex;
       justify-content: center;
       align-items: center;
    }
    img {
      margin-top: 4px;
      height: 32px;
      margin-right:15px;
    }
    // span {
    //   font-weight: 500;
    // }
  }
  .check-product-btn {
    cursor: pointer;
    width: 32px;
    height: 32px;
    line-height: 32px;
    text-align: center;
    display: inline-block;
    font-size: 16px;
    color: #1a173b;
    margin-left: 12px;
  }
  .check-product-btn:hover {
    width: 32px;
    height: 32px;
    display: inline-block;
    border-radius: 4px;
    background: #ebeef1;
    text-align: center;
    line-height: 32px;
  }
  .select {
    margin-left: 10px;
    width: 76px;
  }
  .nav {
    flex: 1;
    // margin-left: 45px;
  }
  .right-dis {
    display: flex;
    align-items: center;
    .help-icon {
      width: 32px;
      height: 32px;
      line-height: 32px;
      text-align: center;
      display: inline-block;
      font-size: 18px;
      color: #1a173b;
    }
    .help-icon:hover {
      width: 32px;
      height: 32px;
      display: inline-block;
      border-radius: 4px;
      background: #ebeef1;
      text-align: center;
      line-height: 32px;
      // border-radius:50% ;
      // color:#fff;
    }
    .login-btns {
      display: flex;
      .text-btn {
        color: $--color-font;
        font-size: 14px;
        margin-left: 24px;
        cursor: pointer;
        padding: 8px;
        &:hover {
          color: #ea5519;
        }
      }
      .text-btn-back {
        color: $--color-font;
        font-size: 14px;
        margin-left: 24px;
        background-color: #f9f9f9;
        cursor: pointer;
        padding: 8px;
        border-radius: 3px;
        &:hover {
          color: #ea5519;
          background-color: rgba(234, 85, 25, 0.1);
        }
      }
      .user-name {
        // color: #E0E0E0;
        margin-left: 10px;
      }
      .head {
        display: flex;
        align-items: center;
        // margin-left: 15px;
        span {
          line-height: 24px;
          margin-right: 12px;
          // color: #E0E0E0;
          &.color {
            color: $--color-font;
          }
        }
        //标记
        /deep/.el-badge {
          .el-badge__content {
            border: none;
            background: $--color-default;
          }
        }
        .head-img {
          cursor: pointer;
          border-radius: 50%;
          height: 100%;
          .svg-icon {
            font-size: 24px;
            transform: translateX(-50%);
            position: relative;
            left: 50%;
          }
        }
      }
    }
  }
}
.head-user {
  width: 24px;
  height: 24px;
  border-radius: 50%;
  color: #fff;
  background: #5e80ff;
  text-align: center;
  display: inline-block;
  font-size: 12px;
  margin-right:0px!important;
}
</style>
